import { LogManager } from '../../LogManager'
import type { GeoAnalyticsSink } from './geo-analytics'

export const logManagerSink: GeoAnalyticsSink = ({ name, data, timestamp }) => {
	LogManager.info({
		...data,
		message: `[geo-analytics] ${name}`,
		_geoEvent: name,
		_geoTimestamp: timestamp,
	})
}

export const fullStorySink: GeoAnalyticsSink = ({ name, data }) => {
	if (typeof window !== 'undefined') {
		const w = window as unknown as Record<string, unknown>
		const fs = w.FS as { event?: (name: string, data: Record<string, unknown>) => void } | undefined
		fs?.event?.(name, data)
	}
}
